<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>用户任务计划</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search" style="align-items: center;">
            <div style="margin: 10px 1vh 10px 0;">
                <el-button type="success" size="small" @click.native="addMethods">新增用户任务</el-button>
            </div>
            <div style="margin-right: 2vh;">
                <el-input placeholder="请输入用户id" prefix-icon="el-icon-search" size="small" v-model="userId"
                    @keyup.enter.native="Query"></el-input>
            </div>
            <div style="margin-right: 2vh;">
                <el-input placeholder="请输入任务名" prefix-icon="el-icon-search" size="small" v-model="taskName"
                    @keyup.enter.native="Query"></el-input>
            </div>
            <div style="margin-right: 2vh;">
                <el-select v-model="quarterValue" placeholder="请选择季度" size="small" clearable style="width: 220px;">
                    <el-option v-for="item in quarterOptions" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </div>
            <div style="margin-right: 2vh;">
                <el-select v-model="monthValue" placeholder="请选择月份" size="small" clearable style="width: 220px;">
                    <el-option v-for="item in monthOptions" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </div>
            <div> <el-button type="primary" size="small" @click.native="Query">查询</el-button></div>
            <div style="margin-left:20px;"> <el-button type="success" size="small"
                    @click.native="resetting">重置</el-button>
            </div>
        </div>
        <div class="list" style="margin-top: 20px;">
            <el-table :data="groupTaskList" style="width: 100%" size="mini" stripe :row-class-name="tableRowClassName">
                <el-table-column prop="id" label="id" width="50"></el-table-column>
                <el-table-column prop="user_id" label="用户id"></el-table-column>
                <el-table-column prop="task_name" label="任务名"></el-table-column>
                <el-table-column prop="month" label="月份"></el-table-column>
                <el-table-column prop="quarterly" label="季度"></el-table-column>
                <el-table-column prop="begin_time" label="开始时间"></el-table-column>
                <el-table-column prop="end_time" label="结束时间"></el-table-column>
                <el-table-column fixed="right" label="操作" width="380">
                    <template slot-scope="scope">
                        <el-button size="mini" type="info"
                            @click="addUserTask(scope.$index, scope.row)">添加计划任务</el-button>
                        <el-button size="mini" type="primary"
                            @click="goToTaskData(scope.$index, scope.row)">跳转任务</el-button>
                        <el-button size="mini" type="success"
                            @click="putGroupTaskList(scope.$index, scope.row)">修改</el-button>
                        <el-button size="mini" type="danger"
                            @click="delGroupTaskList(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
                :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="提示" :visible.sync="dialogDelete" width="30%" center>
            <div style="text-align: center;font-size: 25px;">是否删除这条数据</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogDelete = false">取 消</el-button>
                <el-button type="danger" @click="clickDelete">删 除</el-button>
            </span>
        </el-dialog>
        <!-- 添加 -->
        <el-dialog title="添加数据" :visible.sync="dialogAddData" top="3%" width="80%">
            <div>
                <div class="search_style">
                    <div style="margin-right: 20px;">
                        <el-input placeholder="请输入手机号" prefix-icon="el-icon-search" size="small" clearable v-model="key"
                            @keyup.enter.native="QueryAdd"></el-input>
                    </div>
                    <div style="margin-right: 20px;">
                        <el-input placeholder="请输入用户名" prefix-icon="el-icon-search" size="small" clearable
                            v-model="user_name" @keyup.enter.native="QueryAdd"></el-input>
                    </div>
                    <div style="margin-right: 20px;">
                        <el-input placeholder="请输入用户id" prefix-icon="el-icon-search" size="small" clearable
                            v-model="user_id" @keyup.enter.native="QueryAdd"></el-input>
                    </div>
                    <div style="margin-right: 20px;"> <el-button type="primary" size="small"
                            @click.native="QueryAdd">查询</el-button>
                    </div>
                    <div> <el-button type="warning" size="small" @click.native="resettingAdd">重置</el-button></div>
                </div>
                <div class="list" style="margin-top: 20px;min-height: 100px;margin-bottom: 20px;">
                    <el-table :data="userList" border style="width: 100%" :row-class-name="tableRowClassName"
                        size="small" max-height="300px">
                        <el-table-column prop="id" label="用户id" fixed width="70"></el-table-column>
                        <el-table-column prop="name" label="用户名" fixed width="75"></el-table-column>
                        <el-table-column prop="mobile" label="手机号" width="95"></el-table-column>
                        <el-table-column prop="ctime" label="注册时间" width="133"></el-table-column>
                        <el-table-column prop="last_login_time" label="最后登录时间" width="133"></el-table-column>
                        <el-table-column prop="reg_days" label="注册总天数" width="60"></el-table-column>
                        <el-table-column prop="login_count" label="登录次数" width="50"></el-table-column>
                        <el-table-column prop="login_days" label="登陆总天数" width="60"></el-table-column>
                        <el-table-column prop="session_duration" label="登录总时长" width="125"></el-table-column>
                        <el-table-column prop="age" label="年龄" width="50"></el-table-column>
                        <el-table-column prop="gender" label="性别" width="50"></el-table-column>
                        <el-table-column prop="height" label="身高(cm)" width="75"></el-table-column>
                        <el-table-column prop="weight" label="体重(kg)" width="70"></el-table-column>
                        <el-table-column prop="district" label="更多操作" fixed="right" width="100">
                            <template slot-scope="scope">
                                <el-button type="success" size="mini"
                                    @click="copyMethods(scope.row.id, scope.row)">选择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <el-form :model="addData" :rules="rules" ref="addData">
                <el-form-item label="用户id" :label-width="formLabelWidth" prop="user_id">
                    <el-input style="width: 200px;" v-model="addData.user_id"></el-input>
                </el-form-item>
                <el-form-item label="任务名" :label-width="formLabelWidth" prop="task_name">
                    <el-input style="width: 200px;" v-model="addData.task_name" autocomplete="off"
                        placeholder="请输入任务名"></el-input>
                </el-form-item>
                <el-form-item label="季度" :label-width="formLabelWidth" prop="quarterly">
                    <el-select v-model="addData.quarterly" placeholder="请选择季度" clearable>
                        <el-option v-for="item in quarterOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="月份" :label-width="formLabelWidth" prop="month">
                    <el-select v-model="addData.month" placeholder="请选择月份" clearable>
                        <el-option v-for="item in monthOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始时间" :label-width="formLabelWidth" prop="begin_time">
                    <el-date-picker v-model="addData.begin_time" type="datetime" placeholder="请选择开始时间"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" :label-width="formLabelWidth" prop="end_time">
                    <el-date-picker v-model="addData.end_time" type="datetime" placeholder="请选择结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogAdd">取 消</el-button>
                <el-button type="primary" @click="submitFormAdd">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 修改 -->
        <el-dialog title="修改用户任务" :visible.sync="dialogEditData" width="50%">
            <el-form :model="editData" :rules="rules" ref="editData">
                <el-form-item label="用户任务id" :label-width="formLabelWidth" prop="id">
                    <el-input style="width: 200px;" v-model="editData.id" :disabled="true">
                    </el-input>
                </el-form-item>
                <el-form-item label="用户id" :label-width="formLabelWidth" prop="user_id">
                    <el-input style="width: 200px;" v-model="editData.user_id" type="number" :disabled="true">
                    </el-input>
                </el-form-item>
                <el-form-item label="用户任务名" :label-width="formLabelWidth" prop="task_name">
                    <el-input style="width: 200px;" v-model="editData.task_name" autocomplete="off"
                        placeholder="请输入用户任务名"></el-input>
                </el-form-item>
                <el-form-item label="季度" :label-width="formLabelWidth" prop="quarterly">
                    <el-select v-model="editData.quarterly" placeholder="请选择季度" clearable>
                        <el-option v-for="item in quarterOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="月份" :label-width="formLabelWidth" prop="month">
                    <el-select v-model="editData.month" placeholder="请选择月份" clearable>
                        <el-option v-for="item in monthOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始时间" :label-width="formLabelWidth" prop="begin_time">
                    <el-date-picker v-model="editData.begin_time" type="datetime" placeholder="请选择开始时间"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" :label-width="formLabelWidth" prop="end_time">
                    <el-date-picker v-model="editData.end_time" type="datetime" placeholder="请选择结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogEdit">取消</el-button>
                <el-button type="primary" @click="submitFormEdit">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加任务到用户" :visible.sync="dialogAddToUserGroup" width="40%" center>
            <el-form :model="addToUserGroupForm" :rules="addToUserGroupRules" ref="addToUserGroupForm">
                <el-form-item label="任务ID" prop="task_id">
                    <el-input v-model="addToUserGroupForm.task_id" disabled style="width: 200px;" />
                </el-form-item>
                <el-form-item label="用户ID" prop="user_id">
                    <el-input v-model="addToUserGroupForm.user_id" disabled style="width: 200px;" />
                </el-form-item>
                <el-form-item label="计划组名称" prop="group_name">
                    <el-select v-model="addToUserGroupForm.group_name" placeholder="请选择计划组" style="width: 200px;">
                        <el-option v-for="(item, index) in groupOptions" :key="index" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="添加手指操">
                    <el-select v-model="addToUserGroupForm.add_finger" placeholder="是否每天添加手指操" style="width: 200px;">
                        <el-option v-for="item in taskOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <!-- 新增情绪任务选择（默认空） -->
                <el-form-item label="添加情绪任务">
                    <el-select v-model="addToUserGroupForm.add_emotion" placeholder="是否每天添加情绪任务" style="width: 200px;">
                        <el-option v-for="item in taskOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancel">取消</el-button>
                <el-button type="primary" @click="submitAddToUserGroup">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            monthOptions: [
                { value: 1, label: '1月' },
                { value: 2, label: '2月' },
                { value: 3, label: '3月' },
                { value: 4, label: '4月' },
                { value: 5, label: '5月' },
                { value: 6, label: '6月' },
                { value: 7, label: '7月' },
                { value: 8, label: '8月' },
                { value: 9, label: '9月' },
                { value: 10, label: '10月' },
                { value: 11, label: '11月' },
                { value: 12, label: '12月' }
            ],
            quarterOptions: [
                { value: 1, label: '第一季度' },
                { value: 2, label: '第二季度' },
                { value: 3, label: '第三季度' },
                { value: 4, label: '第四季度' }
            ],
            formLabelWidth: '150px',
            pages: 1,
            limit: 10,
            groupTaskList: [],
            total: 0,
            userId: '', // 查询用用户id
            taskName: '', // 查询用任务名
            quarterValue: '', // 查询用季度
            monthValue: '', // 查询用月份
            dialogDelete: false,
            delData: {},
            key: '',
            user_name: '',
            user_id: '',
            userList: [],
            dialogAddData: false,
            addData: {
                user_id: '',
                task_name: '',
                quarterly: '',
                month: '',
                begin_time: '',
                end_time: ''
            },
            dialogEditData: false,
            editData: {
                id: 0,
                user_id: '',
                task_name: '',
                quarterly: '',
                month: '',
                begin_time: '',
                end_time: ''
            },
            rules: {
                user_id: [
                    { required: true, message: '请选择用户', trigger: 'blur' }
                ],
                task_name: [
                    { required: true, message: '请输入任务名', trigger: 'blur' }
                ]
            },
            dialogAddToUserGroup: false,
            addToUserGroupForm: {
                task_id: '',
                group_name: '',
                user_id: '',
                add_finger: null,  // 是否添加手指操任务
                add_emotion: null  // 是否添加情绪任务
            },
            addToUserGroupRules: {
                group_name: [
                    { required: true, message: '请选择计划组名称', trigger: 'change' }
                ]
            },
            groupOptions: [
                { value: 'SCD/MCI组', label: 'SCD/MCI组' },
                { value: '轻度痴呆组', label: '轻度痴呆组' },
                { value: '中度痴呆组', label: '中度痴呆组' }
            ],
            taskOptions: [
                { value: true, label: '是' },
                { value: false, label: '否' },
            ],
        }
    },
    created() {
        this.getGroupTaskList()
    },
    methods: {
        Query() {
            this.pages = 1;
            this.getGroupTaskList();
        },
        resetting() {
            this.userId = '';
            this.taskName = '';
            this.quarterValue = '';
            this.monthValue = '';
            this.getGroupTaskList();
        },
        handleSizeChange(val) {
            this.limit = val;
            this.getGroupTaskList()
        },
        handleCurrentChange(val) {
            this.pages = val;
            this.getGroupTaskList()
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 1) {
                return '';
            } else {
                return 'success-row';
            }
        },
        // 获取任务列表（参数拼接）
        getGroupTaskList() {
            let queryStr = `pages=${this.pages}&limit=${this.limit}`;

            if (this.userId) queryStr += `&user_id=${this.userId}`;
            if (this.taskName) queryStr += `&task_name=${encodeURIComponent(this.taskName)}`;
            if (this.quarterValue) queryStr += `&quarterly=${this.quarterValue}`;
            if (this.monthValue) queryStr += `&month=${this.monthValue}`;

            console.log(queryStr, 'queryStr')
            this.$get(`/v1/admin/user-task?${queryStr}`, {}).then((res) => {
                console.log(res);
                if (res.data.status !== 'success') {
                    this.$msg(res.data.msg);
                } else {
                    this.total = res.data.total;
                    this.groupTaskList = res.data.data;
                }
            });
        },
        // 删除任务（参数拼接）
        delGroupTaskList(index, row) {
            this.dialogDelete = true
            this.delData = row
        },
        clickDelete() {
            this.$delete(`/v1/admin/user-task?id=${this.delData.id}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    this.$message.success('删除成功')
                    this.getGroupTaskList()
                    this.dialogDelete = false
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        // 添加任务（对象形式）
        addMethods() {
            this.getUserList()
            this.dialogAddData = true
        },
        getUserList() {
            this.$get(`/v1/admin/users?pages=${this.pages}&limit=${this.limit}&key=${this.key}&user_name=${this.user_name}&user_id=${this.user_id}`, {})
                .then((res) => {
                    if (res.data.status === 'success') {
                        this.userList = res.data.data.data;
                    } else {
                        this.$msg(res.data.msg)
                    }
                });
        },
        copyMethods(index, row) {
            this.addData.user_id = row.id
        },
        QueryAdd() {
            this.pages = 1;
            this.getUserList();
        },
        resettingAdd() {
            this.key = this.user_name = this.user_id = ''
            this.pages = 1;
            this.getUserList();
        },
        submitFormAdd() {
            this.$refs.addData.validate((valid) => {
                if (valid) {
                    const apiData = {
                        user_id: this.addData.user_id,
                        task_name: this.addData.task_name,
                        quarterly: this.addData.quarterly,
                        month: this.addData.month,
                        begin_time: this.addData.begin_time,
                        end_time: this.addData.end_time
                    };

                    // 过滤掉值为空字符串或null的字段
                    Object.keys(apiData).forEach(key => {
                        if (apiData[key] === '' || apiData[key] === null) {
                            delete apiData[key];
                        }
                    });
                    console.log(apiData, 'apiDataapiData')
                    this.$post(`/v1/admin/user-task`, apiData).then((res) => {
                        if (res.data.status === 'success') {
                            this.$message.success(res.data.msg)
                            this.getGroupTaskList()
                            this.closeDialogAdd()
                        } else {
                            this.$msg(res.data.msg)
                        }
                    });
                }
            });
        },
        closeDialogAdd() {
            this.key = this.user_name = this.user_id = ''
            this.$refs.addData.resetFields();
            this.addData = {
                user_id: '',
                task_name: '',
                quarterly: '',
                month: '',
                begin_time: '',
                end_time: ''
            }
            this.dialogAddData = false;
        },
        // 修改任务（对象形式）
        putGroupTaskList(index, row) {
            this.editData = {
                id: row.id,
                user_id: row.user_id,
                task_name: row.task_name,
                quarterly: row.quarterly || '',
                month: row.month || '',
                begin_time: row.begin_time || '',
                end_time: row.end_time || ''
            };
            this.dialogEditData = true;
        },
        submitFormEdit() {
            this.$refs.editData.validate((valid) => {
                if (valid) {
                    const apiData = {
                        id: this.editData.id,
                        user_id: this.editData.user_id,
                        task_name: this.editData.task_name,
                        quarterly: this.editData.quarterly || null,
                        month: this.editData.month || null,
                        begin_time: this.editData.begin_time || null,
                        end_time: this.editData.end_time || null
                    };

                    this.$put(`/v1/admin/user-task`, apiData).then((res) => {
                        if (res.data.status === 'success') {
                            this.$message.success(res.data.msg)
                            this.getGroupTaskList()
                            this.closeDialogEdit()
                        } else {
                            this.$msg(res.data.msg)
                        }
                    });
                }
            });
        },
        closeDialogEdit() {
            this.dialogEditData = false;
            this.$refs.editData.resetFields();
            this.editData = {
                id: 0,
                user_id: '',
                task_name: '',
                quarterly: '',
                month: '',
                begin_time: '',
                end_time: ''
            };
        },
        goToTaskData(index, row) {
            console.log(row, 'rowrow')
            this.$router.push({
                path: '/taskData',
                query: {
                    taskId: row.id,
                }
            });
        },
        addUserTask(index, row) {
            console.log(row, 'row')
            // 打开弹窗并设置task_id
            this.addToUserGroupForm.task_id = row.id;
            this.addToUserGroupForm.user_id = row.user_id
            this.dialogAddToUserGroup = true;
        },

        // 提交添加到用户/用户组表单
        submitAddToUserGroup() {
            this.$refs.addToUserGroupForm.validate((valid) => {
                if (valid) {
                    // 构建请求参数
                    const apiData = {
                        group_name: this.addToUserGroupForm.group_name,
                        task_id: Number(this.addToUserGroupForm.task_id),
                        user_id: Number(this.addToUserGroupForm.user_id),
                        add_finger: this.addToUserGroupForm.add_finger,
                        add_emotion: this.addToUserGroupForm.add_emotion
                    };

                    // 调用API
                    this.$post(`/v1/admin/add-task-to-user-or-group`, apiData).then((res) => {
                        if (res.data.status === 'success') {
                            this.$message.success(res.data.msg);
                            this.resetAddToUserGroupForm(); // 清空表单
                            this.dialogAddToUserGroup = false;
                        } else {
                            this.$msg(res.data.msg);
                        }
                    });
                }
            });
        },

        // 处理取消操作
        handleCancel() {
            this.resetAddToUserGroupForm(); // 清空表单
            this.dialogAddToUserGroup = false;
        },

        // 重置添加到用户/用户组表单
        resetAddToUserGroupForm() {
            this.addToUserGroupForm = {
                task_id: '', // 保留task_id
                user_id: '',
                group_name: '', // 清空group_name
                add_finger: null,  // 重置为空值
                add_emotion: null
            };
            this.$nextTick(() => {
                this.$refs.addToUserGroupForm && this.$refs.addToUserGroupForm.clearValidate();
            });
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.flex_box{
    margin: 12px;
    text-align right
}

.flex_box div {
    margin 10px
}

.right_box div {
    margin 10px
}
.right_box{
    color: red;
}

.dialog_style{
    display flex
    align-items center
    justify-content center
    font-size 19px
    color #000
}

   .el-select .el-input {
      width: 200px;
    }
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  
      .el-table .success-row {
        background: #f0f9eb;
      }
  
      .search
        margin 20px 0
        display flex
        flex-wrap wrap
        align-items center
        justify-content flex-start
        input
          margin-right 10px
        .add
          padding-left 100px
  
      .list
        min-height 550px
        border 1px solid #EBEEF5
        .edit_icon
          width 20px
          height 20px
          margin-left 16px
          border 1px solid  #ccc
          border-radius 4px
  
  </style>
<style scoped>
.custom-content {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 100px;
    line-height: normal;
}

.search_style {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/user_task_list/user_task/user_task.vue